import React from 'react';
import { Section } from './Section';
export function OpeningHook() {
  return <Section bg="navy-light" data-id="element-176">
      <div className="max-w-4xl mx-auto" data-id="element-177">
        <blockquote className="relative border-l-4 border-gold pl-5 md:pl-12 py-2 md:py-4" data-id="element-178">
          <p className="text-lg md:text-2xl lg:text-3xl font-playfair leading-relaxed text-white mb-4 md:mb-8" data-id="element-179">
            "Si hoy mismo dejaras de recibir tu nómina o las utilidades de tu
            empresa...{' '}
            <span className="text-gold" data-id="element-180">
              ¿cuántos meses podrías mantener el colegio de tus hijos, el seguro
              de gastos médicos y el estilo de vida de tu familia?
            </span>
            "
          </p>
          <p className="text-base md:text-xl text-gray-light leading-relaxed" data-id="element-181">
            Para la mayoría de los ejecutivos en México que ganan más de $80,000
            pesos al mes, la respuesta es alarmante: menos de un año. Has
            construido tu éxito basado en una capacidad de flujo que no tiene
            una estructura de respaldo real.
          </p>
        </blockquote>
      </div>
    </Section>;
}